import { createSlice } from "@reduxjs/toolkit";

const locationSlice = createSlice({
    name: "locations",
    initialState: {},
    reducers: {
        registerLocation: (state, action) => {
            const location = action.payload;
            if (!location?.id) return;

            if (!state[location.id]) {
                state[location.id] = location;
            } else {
                console.warn(
                    `⚠️ Location ${location.id} already exists — skipping overwrite.`
                );
            }
        },

        bulkRegisterLocations: (state, action) => {
            action.payload.forEach((location) => {
                if (!location?.id) return;

                if (!state[location.id]) {
                    state[location.id] = location;
                } else {
                    console.warn(
                        `⚠️ Location ${location.id} already exists — skipping overwrite.`
                    );
                }
            });
        }
    }
});

export const {
    registerLocation,
    bulkRegisterLocations
} = locationSlice.actions;

export default locationSlice.reducer;
